import React, { useState } from "react";
import { Button, FormFieldSet, LogoLoader, showToast } from "../../../components";
import { passwordUpdate } from "../../../redux/slices/setting/settingApi";
import { useSelector } from "react-redux";

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const handlePasswordSave = async () => {
    if (loading) return;
    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[&()#*$@])[A-Za-z\d&()#*$@]+$/;

    if (!newPassword) {
      showToast("Password is required!", "error", 2000);
      return;
    }

    if (newPassword.length < 8) {
      showToast("Password must be at least 8 characters!", "error", 2000);
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      showToast(
        "Password must include uppercase, lowercase, number, and one special character (& ( ) # * $ @).",
        "error",
        4000
      );
      return;
    }

    if (!user?.data._id) {
      showToast("User ID not found!", "error", 2000);
      return;
    }

    try {
      setLoading(true);
      const res = await passwordUpdate({
        id: user?.data._id,
        password: newPassword,
      });

      if (res?.data) {
        showToast("Password updated successfully", "success", 2000);
        setNewPassword("");
        setConfirmPassword("");
      } else {
        showToast("Failed to update password", "error", 2000);
      }
    } catch (err) {
      console.error("Password update failed:", err);
      showToast("Error while updating password", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveClick = () => {
    if (newPassword !== confirmPassword) {
      showToast("Passwords do not match!", "error", 2000);
      return;
    }
    handlePasswordSave();
  };

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
        <LogoLoader />
      </div>
    );
  }
  return (
    <div className="flex gap-3 my-3 mx-1">
      {/* <FormFieldSet
        type="password"
        noGenerate
        title="Current Password"
        placeholder="Current Password"
      /> */}

      <FormFieldSet
        type="password"
        noGenerate
        title="New Password"
        placeholder="New Password"
        value={newPassword}
        onChange={(e) => {
          setNewPassword(e.target.value);
        }}
      />
      <FormFieldSet
        type="password"
        noGenerate
        title="Confirm Password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={(e) => {
          setConfirmPassword(e.target.value);
        }}
      />
      <div className="flex justify-start items-end">
        <Button title={"Save"} onClick={handleSaveClick} />
      </div>
    </div>
  );
};

export default ChangePassword;
